import { useRef } from 'react';
import { ChevronDown } from 'lucide-react';

const DropdownFilter = ({ options, value, onChange }) => {
  const dropdownRef = useRef(null);

  const toggle = (key) => {
    onChange((prev) =>
      prev.includes(key) ? prev.filter((t) => t !== key) : [...prev, key]
    );
    if (dropdownRef.current) dropdownRef.current.open = false;
  };

  const label =
    value.length === options.length
      ? 'Type'
      : options.filter((o) => value.includes(o.key)).map((o) => o.label).join(', ');

  return (
    <div className="p-1 bg-base-200 rounded-xl shrink-0">
      <details className="dropdown" ref={dropdownRef}>
        <summary className="btn btn-sm rounded-lg btn-ghost gap-1.5 font-semibold hover:bg-transparent">
          {label}
          <ChevronDown size={14} />
        </summary>
        <ul className="dropdown-content menu bg-base-100 rounded-xl shadow-lg border border-base-200 p-2 w-48 z-10 mt-1">
          {options.map(({ key, label: optLabel }) => (
            <li key={key}>
              <label className="flex items-center gap-2 cursor-pointer px-2 py-1.5 rounded-lg hover:bg-base-200">
                <input
                  type="checkbox"
                  className="checkbox checkbox-sm"
                  checked={value.includes(key)}
                  onChange={() => toggle(key)}
                />
                <span className="text-sm">{optLabel}</span>
              </label>
            </li>
          ))}
        </ul>
      </details>
    </div>
  );
};

export default DropdownFilter;
